import {
  GET_QUESTIONNAIRE_QUESTIONS,
  GET_QUESTIONNAIRE_QUESTIONS_SUCCESS,
  GET_QUESTIONNAIRE_QUESTIONS_ERROR,
  GET_QUESTIONNAIRE_ANSWERS,
  GET_QUESTIONNAIRE_ANSWERS_SUCCESS,
  GET_QUESTIONNAIRE_ANSWERS_ERROR,
  SAVE_QUESTIONNAIRE_ANSWERS,
  SAVE_QUESTIONNAIRE_ANSWERS_SUCCESS,
  SAVE_QUESTIONNAIRE_ANSWERS_ERROR,
} from "../../constants/action-types";

export const questionnaireInitialState = {
  questions: {
    educationalQuestions: [],
    applicationInPractiseQuestions: [],
    evaluationQuestions: [],
  },
  answers: {
    educationalAnswers: [],
    applicationInPractiseAnswers: [],
    evaluationAnswers: [],
  },
  isQuestionsFetching: false,
  isAnswersUpdating: false,
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_QUESTIONNAIRE_QUESTIONS: {
      return {
        ...state,
        isQuestionsFetching: true,
      };
    }
    case GET_QUESTIONNAIRE_QUESTIONS_SUCCESS: {
      return {
        ...state,
        isQuestionsFetching: false,
        questions: {
          educationalQuestions: payload.educationalQuestions || [],
          applicationInPractiseQuestions:
            payload.applicationInPractiseQuestions || [],
          evaluationQuestions: payload.evaluationQuestions || [],
        },
      };
    }
    case GET_QUESTIONNAIRE_QUESTIONS_ERROR: {
      return {
        ...state,
        isQuestionsFetching: false,
      };
    }
    case GET_QUESTIONNAIRE_ANSWERS:
    case SAVE_QUESTIONNAIRE_ANSWERS: {
      return {
        ...state,
        isAnswersUpdating: true,
      };
    }
    case GET_QUESTIONNAIRE_ANSWERS_SUCCESS: {
      return {
        ...state,
        isAnswersUpdating: false,
        answers: {
          educationalAnswers: payload.educationalAnswers || [],
          applicationInPractiseAnswers:
            payload.applicationInPractiseAnswers || [],
          evaluationAnswers: payload.evaluationAnswers || [],
        },
      };
    }
    case SAVE_QUESTIONNAIRE_ANSWERS_SUCCESS:
    case SAVE_QUESTIONNAIRE_ANSWERS_ERROR:
    case GET_QUESTIONNAIRE_ANSWERS_ERROR: {
      return {
        ...state,
        isAnswersUpdating: false,
      };
    }
    default:
      return state;
  }
};
